<div class="content-div">
          <div class="auto-refresh-warning" *ngIf="anySelected">
          <i class="fal fa-exclamation-triangle"></i>
          {{ 'realtime:queuedetails_lang_stoprefresh' | i18next }}
        </div>
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button id="help-btn-real-time-overview-sched" type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>
  <div class="top-bar">
    <span class="page-header">{{ 'realtime:FeatureCallback' | i18next }}<span class="header-details">{{ queueName || '‒' }}</span></span>
  </div>
  <div class="top-bar buttons-bar">
    <app-basic-button id="select-all-btn-real-time-overview-sched" *ngIf="!allSelected && propertyAllowDelete && dataSource.data.length > 0" type="secondary" [text]="'Select all' | i18next"  size="small"
      (click)="toggleSelectAll(true)"></app-basic-button>
    <app-basic-button id="deselect-all-btn-real-time-overview-sched" *ngIf="allSelected && propertyAllowDelete" type="secondary" [text]="'Deselect all' | i18next" size="small"
      (click)="toggleSelectAll(false)"></app-basic-button>

    <app-basic-button id="edit-reserved-btn-real-time-overview-sched" *ngIf="canEditReserved && anySelected" type="secondary" [text]="'realtime:editReservedPreferred' | i18next" [disabled]="!canEditReserved" size="small"
      (click)="onEditReserved()"></app-basic-button>
    <app-basic-button id="delete-selected-btn-real-time-overview-sched" *ngIf="propertyAllowDelete && anySelected" type="decline" size="small"
      [disabled]="!anySelected" (click)="onDeleteSelected()"><i class="fal fa-times fs-14"></i> {{ 'reports:Delete' | i18next }}</app-basic-button>


    <div class="right">
      <app-filter-input id="filter-input-real-time-overview-sched" [(model)]="filter" (modelChange)="applyFilterFromProperty()"
        [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next" [width]="'350px'"></app-filter-input>
    </div>
  </div>

  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <!-- No-data template -->
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 full-width-table">

      <!-- Select -->
      <ng-container *ngIf="propertyAllowDelete" matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="text-center"></th>
        <td mat-cell *matCellDef="let r" class="text-center">
           <app-basic-checkbox id="checkbox-{{r.requestId}}-real-time-overview-sched" [model]="selected[r.requestId] || false" (change)="toggleOne(r.requestId, $event)" [attr.data-media]="r.mediaType" ></app-basic-checkbox>
        </td>
      </ng-container>

      <!-- Caller -->
      <ng-container matColumnDef="caller">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:numberFrom' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r">{{ r.caller || r.formattedNumberFrom }}</td>
      </ng-container>

      <!-- Description -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:profile_description' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" [title]="r.description || '‒'">
          {{ r.description || '‒' }}
        </td>
      </ng-container>

      <!-- Ordered time -->
      <ng-container matColumnDef="formattedOrderedTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:scheduledcallback_orderedtime' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.formattedOrderedTime }}</td>
      </ng-container>

      <!-- Scheduled time -->
      <ng-container matColumnDef="formattedScheduledTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:scheduledcallback_scheduledtime' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="scheduledtime text-right">
          {{ r.formattedScheduledTime }}
        </td>
      </ng-container>

      <!-- Reserved preferred -->
      <ng-container matColumnDef="formattedReservedFlag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:reservedPreferred' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="reservedflag">
          {{ r.formattedReservedFlag }}
        </td>
      </ng-container>

      <!-- Preview -->
      <ng-container matColumnDef="preview">
        <th mat-header-cell *matHeaderCellDef class="text-center">
          {{ 'realtime:queuedetails_lang_preview' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-center">
          <app-basic-button id="preview-btn-{{r.requestId}}" type="secondary" isIcon="true" size="small" *ngIf="isEmailMedia(r.mediaType); else dash"
            (click)="onPreview(r, $event)">
            <img src="assets/Img/eye_ico.svg" alt="Preview" />
          </app-basic-button>
          <ng-template #dash>‒</ng-template>
        </td>
      </ng-container>



      <!-- Header & rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
          [attr.id]="row.requestId"
          [attr.title]="row.description || null">
      </tr>

      <!-- No data row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>
    </table>

    <div class="rows-status" *ngIf="dataSource.data?.length">
      {{ 'realtime:rowsShown' | i18next : { defaultValue: 'Showing' } }}
      {{ curDisplayRows }}
      {{ 'realtime:rows' | i18next : { defaultValue: 'rows' } }}
    </div>

    <div class="center" *ngIf="hasMore && !isLoading">
      <a id="load-more-link-real-time-overview-sched" href="#" style="color:#4e64ca" (click)="$event.preventDefault(); onLoadMore()">
        {{ 'realtime:getnext' | i18next : { defaultValue: 'Get next' } }}
      </a>
    </div>
  </div>
</div>
